import { useApiClientProject } from '~/@api/client/useApiClientProject'
import type { IListFilteredProjectsOkResponse } from '~/@api/generated-api-types-project/Api'
import type { ProjectsItem } from '../_project_types/project.types'

// Jediná hranica, kde sa generované IProjectListItem[] zužuje na ProjectsItem[]
// (WithTypedCollateral — collateral kategórie sú runtime 1:1 enum hodnoty,
// swagger ich len typuje ako plain string; viď project.types.ts).
type ProjectsListResponse = Omit<IListFilteredProjectsOkResponse, 'items'> & {
  items: ProjectsItem[]
}

function useProjects(statuses: Array<ProjectsItem['statusId']>) {
  const client = useApiClientProject()

  async function fetchProjects() {
    return client.project
      .projectControllerGetProjects(
        {
          statuses,
        },
        { secure: true }
      )
      .then((resp) => resp.data as ProjectsListResponse)
  }

  return {
    fetchProjects,
  }
}

export { useProjects }
